import React from 'react';
import { Row, Col } from 'react-bootstrap';
import NurseDashboardIntakePanel from './NurseDashboardIntakePanel';
import NurseWaitingListPanel from './NurseWaitingListPanel';

export default function NursePosteInfirmieSection({
  id,
  ariaLabel,
  badge,
  title,
  description,
  workSiteId,
  siteName,
  toast,
  consultations,
  loading,
  onRefresh,
  onIntakeSuccess,
  onOpenConsultation,
  onSeeAllFile,
  todayOnly = true
}) {
  return (
    <section
      id={id}
      className="recv-dash-primary recv-dash-primary--ops nr-dash-ops recv-no-print mb-4"
      aria-label={ariaLabel}
    >
      <div className="recv-dash-primary__head recv-dash-primary__head--ops mb-4">
        <div>
          {badge ? <span className="recv-dash-primary__badge">{badge}</span> : null}
          <h2 className="recv-dash-primary__title mb-1">{title}</h2>
          <p className="recv-dash-primary__desc mb-0">{description}</p>
        </div>
      </div>
      <Row className="g-4 recv-dash-twocol">
        <Col xs={12} xl={6}>
          <NurseDashboardIntakePanel
            workSiteId={workSiteId}
            siteName={siteName}
            toast={toast}
            onIntakeSuccess={onIntakeSuccess}
          />
        </Col>
        <Col xs={12} xl={6}>
          <NurseWaitingListPanel
            consultations={consultations}
            loading={loading}
            siteName={siteName}
            onRefresh={onRefresh}
            onOpenConsultation={onOpenConsultation}
            onSeeAllFile={onSeeAllFile}
            todayOnly={todayOnly}
          />
        </Col>
      </Row>
    </section>
  );
}
